require("./bootstrap");

import Sortable from "sortablejs";
import Chart from "chart.js";
import * as Ladda from 'ladda';
import * as ChartAnnotation from "chartjs-plugin-annotation";
import { initContactTimezoneClock } from "./contact-timezone-clock";
import { renderCopyEmailIcon } from "./utils/copyEmailIcon";

window.Sortable = Sortable;
window.Chart = Chart;
window.ChartAnnotation = ChartAnnotation;
window.Ladda = Ladda;

const PAGE_LENGTH_COOKIE = 'tablePageLengthDefaults';
const PAGE_LENGTH_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

function readPageLengthDefaults() {
    const match = document.cookie.match(new RegExp('(?:^|; )' + PAGE_LENGTH_COOKIE + '=([^;]*)'));
    if (!match) return {};
    try {
        return JSON.parse(decodeURIComponent(match[1])) || {};
    } catch (e) {
        return {};
    }
}

window.getSavedPageLength = function (tableId) {
    const defaults = readPageLengthDefaults();
    return typeof defaults[tableId] === 'number' ? defaults[tableId] : null;
};

window.setSavedPageLength = function (tableId, length) {
    const defaults = readPageLengthDefaults();
    defaults[tableId] = length;
    document.cookie = PAGE_LENGTH_COOKIE + '=' + encodeURIComponent(JSON.stringify(defaults)) + '; max-age=' + PAGE_LENGTH_COOKIE_MAX_AGE + '; path=/; SameSite=Lax';
};

const COPY_EMAIL_FEEDBACK_MS = 1500;

function copyEmailToClipboard(email) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(email);
    }
    return new Promise((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = email;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy') ? resolve() : reject(new Error('copy failed'));
        } catch (error) {
            reject(error);
        } finally {
            textarea.remove();
        }
    });
}

// Capture phase so the click works inside dropdowns that stop propagation and
// never bubbles into row-level handlers (search result navigation, mailto, etc.).
document.addEventListener('click', (e) => {
    const control = e.target.closest('.js-copy-email');
    if (!control) return;
    e.preventDefault();
    e.stopPropagation();
    const email = control.dataset.copyEmail;
    if (!email || control.classList.contains('copied')) return;
    copyEmailToClipboard(email).then(() => {
        control.classList.add('copied');
        setTimeout(() => control.classList.remove('copied'), COPY_EMAIL_FEEDBACK_MS);
    }).catch(() => {});
}, true);

document.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('js-copy-email')) {
        e.preventDefault();
        e.target.click();
    }
});

// Lives in utils/copyEmailIcon.js so it can be unit-tested; published here for
// the render() callbacks that read it off window.
window.renderCopyEmailIcon = renderCopyEmailIcon;

$(document).ready(function() {
    $('.logout-button').on('click', function (e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: '/logout',
            data: { _token: $('meta[name="csrf-token"]').attr('content') },
            dataType: 'JSON',
            context: this,
            success: function (data) {
                window.location.href = '/'
            },
        });
    });

    $('.prev-user').on('click', function (e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: '/users/loginBack',
            data: { _token: $('meta[name="csrf-token"]').attr('content') },
            dataType: 'JSON',
            context: this,
            success: function (data) {
                window.location.href = '/'
            },
        });
    });

    $('input, textarea').keydown(function (e) {
        if (e.keyCode == 65 && (e.ctrlKey || e.metaKey)) {
            e.target.select()
        }
    });

    initContactTimezoneClock();
});